import { render, staticRenderFns } from "./diskDrive.vue?vue&type=template&id=ff0dbefe&"
import script from "./diskDrive.vue?vue&type=script&lang=js&"
export * from "./diskDrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports